import React, { forwardRef } from 'react';
import { Select } from 'antd';

const AddOnSelect = forwardRef(({ availableAddOns, onChange, value }, ref) => {
	if (!availableAddOns) {
		return null;
	}

	return (
		<Select
			ref={ref}
			mode='multiple'
			optionFilterProp='label'
			onChange={onChange}
			defaultValue={value}
		>
			{availableAddOns.map((addOn) => (
				<Select.Option key={addOn.key} value={addOn.key} label={addOn.name}>
					{addOn.name}
				</Select.Option>
			))}
		</Select>
	);
});

export default AddOnSelect;



// WEBPACK FOOTER //
// ./src/components/AddOnSelect.jsx